<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>分组管理</el-breadcrumb-item>
      <!--      <quit-project />-->
    </el-breadcrumb>

    <el-button type="primary" plain class="btn-add" @click="showAddGroupDialog">上传分组文件</el-button>
    <el-button type="primary" plain class="btn-add" @click="showInputGroupDialog">输入分组</el-button>
    <el-button type="danger" plain @click="onMultipleDel()">批量删除</el-button>
    <span></span>
    <!-- 主体部分 -->
    <el-card class="box-card">
      <el-table :data="group.groupData" max-height="800" ref="multipleTable" @selection-change="handleSelectionChange"
                v-loading="loadingGroup"
                tooltip-effect="dark" :fit="true">
        <el-table-column
          type="selection"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="groupName"
          label="组名"
        >
        </el-table-column>
        <el-table-column
          prop="groupSample"
          label="组内样本"
        >
        </el-table-column>
        <el-table-column
          prop="uploader.userName"
          label="上传者"
        >
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)"
                       style="width:55px;height: 30px">
              编辑
            </el-button>
            <el-button type="danger" plain size="small" @click="handleDelete(scope.$index, scope.row)"
                       style="width:55px;height: 30px">
              删除
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination :child-msg="groupPageChildMsg" @callFather="handlePagePagination"></pagination>
    </el-card>
    <!--    分组文件上传-->
    <el-dialog
      :destroy-on-close="true"
      title="上传分组文件"
      :visible.sync="addGroupDialogVisible"
      style="min-width: 300px"
      width="45%"
    >
      <el-form ref="groupAddForm" :model="groupAddFormData" label-width="0">
        <el-form-item>
          <upload :child-msg="uploadProperty"
                  @callFather="getFile" :component-style="1"
                  :exampleFileName="'group.txt'"
                  ref="uploadChild"></upload>

        </el-form-item>
        <template>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAddGroupDialog">取 消</el-button>
        <el-button type="primary" @click="confirmation">确 定</el-button>
      </span>
    </el-dialog>
    <!--    更改信息界面-->
    <el-dialog
      :destroy-on-close="true"
      title="更改分组文件信息"
      :visible.sync="editGroupDialogVisible"
      width="60%"
    >

      <el-form ref="groupAddForm" :model="groupEditFormData" label-width="40px" style="margin-right: 30px">
        <el-form-item label="组名">
          <el-input v-model="groupEditFormData.editGroupName"></el-input>
        </el-form-item>
        <el-form-item>
          <TransformTable :left-datas="sampleNoInclude" :right-datas="groupEditFormData.editGroupSample"
                          :notice="'注：组内样本数不得少于3个。每组建议6个及以上。分组名不可以为中文'"
                          :leftTitle="'剩余样本'" :rightTitle="'当前组内样本'" :is-group="false" @handleTrans="handleConfirm" @handleTransCancel="handleTransCancel">

          </TransformTable>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :destroy-on-close="true"
      title="输入分组"
      width="60%"
      :visible.sync="inputGroupDialogVisible">
      <TransformTable :left-datas="samples" :right-datas="checkedSampleGroup" :notice="'注：组内样本数不得少于3个。每组建议6个及以上。分组名不可以为中文'"
                      :leftTitle="'样本选择'" :rightTitle="'样本与组'" :is-group="true" @handleTrans="handleConfirm" @handleTransCancel="handleTransCancel">

      </TransformTable>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Upload from '@/components/Upload'
import QuitProject from '@/components/QuitProject'
import {groupSize} from '@/utils/uploadFileSize'
import {isSameArr} from "@/utils/utils";
import TransformTable from "@/components/TransformTable";

export default {
  data() {
    return {
      groupMove: [],
      example: false,
      downloadUrl: '../',
      loadingGroup: true,
      samples: [],
      checkedSamples: [],
      checkedSampleGroup: [],
      prepareToLeft: [],
      inputGroupDialogVisible: false,
      projectId: '',
      groupFlag: false,
      group: {
        groupData: [],
        groupName: []
      },
      value: [],
      groupPageChildMsg: {
        total: 0,
        pageSize: 8,
        currentNum: 1
      },
      groupDataPageparm: {
        currentNum: 1,
        pageSize: 8
      },
      groupAddFormData: {
        uploaderId: '',
        sampleFile: '',
      },
      groupEditFormData: {
        editGroupName: '',
        editGroupSample: [],
        projectId: '',
        groupId: '',
      },
      beforeEditGroupData: {
        editGroupName: '',
        projectId: '',
      },
      addGroupDialogVisible: false,
      editGroupDialogVisible: false,
      user: [],
      uploadProperty: {
        fileSize: groupSize,
        types: new Set(['txt', 'xls'])
      },
      multipleSelectAry: [],
      sampleAll: [],
      sampleNoInclude: [],

    }
  },
  components: {
    TransformTable,
    'pagination': Pagination,
    "quit-project": QuitProject,
    'upload': Upload,
    'transform-table': TransformTable
  },

  created: function () {
    this.projectId = this.$route.query.projectId
    var projectAll = this.$store.getters['right/getUser']
    if (!this.projectId && projectAll && projectAll.projectsRow) {
      this.projectId = projectAll.projectsRow.projectId
    }
    // this.getUserInfo()
    this.getGroupPageData()
  },
  methods: {
    //点击输入分组中的确认按钮
    async saveInputGroup() {
      var groupNameSet = new Set
      var sendData = []
      for (var i = 0; i < this.checkedSampleGroup.length; i++) {
        var item = this.checkedSampleGroup[i]
        if(!item.groupName){
          this.$messageUi.error("组名不能为空")
          return;
        }
        if (groupNameSet.has(item.groupName)) {
          this.$messageUi.error("分组名" + item.groupName + '重复')
          return;
        }
        groupNameSet.add(item.groupName)
        if(item.samples.length<3){
          this.$messageUi.error(`组内样本数不得小于3`)
          return
        }
        sendData.push({
          group: item.groupName,
          samples: item.samples
        })
      }
      const res = await this.$http.post("group/input", {
        "sampleGroup": sendData,
        "projectId": this.projectId
      })
      if (res.code === 200) {
        this.inputGroupDialogVisible = false
        this.$messageUi.success("添加成功")
        this.getGroupPageData()
      } else {
        this.$messageUi.error("添加失败，" + res.message)
      }
    },
    //展示输入分组
    showInputGroupDialog() {
      this.checkedSampleGroup = []
      this.checkedSamples = []
      this.prepareToLeft = []
      this.groupMove = []
      this.getGroupsSampleNames().then(()=> {
          this.inputGroupDialogVisible = true
      }).catch(()=>{
          this.$messageUi.error('分组样本信息获取失败')
      })

    },
    //获取样本名
    async getGroupsSampleNames() {
      return new Promise((resolve, reject) => {
        this.$http.get('group/projectId/' + this.projectId).then(res=>{
            if(res.code===200){
              var samples = []
              res.data.sampleNames.forEach(item => {
                samples.push({
                  sample: item
                })
              })
              this.samples = samples
              this.sampleAll = samples
              resolve()
            }else {
              reject()
            }
        }).catch(()=>{
          reject()
        })
      })

    },
    //展示上传分组文件
    showAddGroupDialog() {
      this.addGroupDialogVisible = true
      // this.getUserByRole('sale')
    },
    //关闭上传分组文件
    closeAddGroupDialog() {
      this.addGroupDialogVisible = false
    },
    //获取分组文件
    getFile(file) {
      if (!file) {
        this.groupAddFormData.sampleFile = ''
      } else {
        this.groupAddFormData.sampleFile = file
      }
    },
    //点击分页
    handlePagePagination(pageparm) {
      this.groupDataPageparm = pageparm
      this.getGroupPageData()
    },
    //获取页面上的分组相关信息
    async getGroupPageData(type) {
      if (type) {
        this.userDataPageparm.currentNum = 1
      }
      var sendData = {
        pageNum: this.groupDataPageparm.currentNum,
        pageSize: this.groupDataPageparm.pageSize,
        projectId: this.projectId
      }
      const res = await this.$http.post('group/all', sendData)
      if (res) {
        if (res.code === 200) {
          this.loadingGroup = false
          const pageData = res.data
          this.group.groupData = pageData.data
          this.groupPageChildMsg.total = pageData.totalNum
          this.groupPageChildMsg.pageSize = pageData.pageSize
          this.groupPageChildMsg.currentNum = pageData.currentNum
          // await this.getUploaderInfo()
        }
      }
    },
    updataData() {
      const divide = Math.floor(this.groupPageChildMsg.total / this.groupDataPageparm.pageSize)
      if (divide + 1 === this.groupDataPageparm.currentNum
        && this.groupPageChildMsg.total % this.groupDataPageparm.pageSize === 1) {
        if (this.groupDataPageparm.currentNum > 1) {
          this.groupDataPageparm.currentNum--
        }
      }
    },
    //点击上传分组的确认按钮
    async confirmation(file) {
      var flag = await this.checkGroupFile(this.groupAddFormData.sampleFile)
      if (!flag) {
        return
      }
      const data = new FormData()
      data.set('sampleFile', this.groupAddFormData.sampleFile)
      data.set('name', this.groupAddFormData.sampleFile.name)
      data.set('uploaderId', this.user.userId ? this.user.userId : 0)
      data.set('projectId', this.projectId)
      const res = await this.$http.post('group/upload', data, {
        'Content-type': 'multipart/form-data'
      })
      if (res) {
        if (res.code === 200) {
          this.closeAddGroupDialog()
          this.getGroupPageData()
          this.$messageUi.success('文件上传成功')
        } else {
          this.$messageUi.error(res.message)
        }
      }

    },
    //点击编辑按钮
handleEdit(index, row) {
      this.getGroupsSampleNames().then(()=>{
        this.checkedSamples = []
        this.prepareToLeft = []//往左移的
        this.groupEditFormData.groupId = row.groupId
        this.groupEditFormData.editGroupName = row.groupName
        this.groupEditFormData.editGroupSample = []
        row.groupSample.split(",").map(item => {
          this.groupEditFormData.editGroupSample.push({
            sample: item
          })
        })
        this.sampleNoInclude = this.sampleAll.filter(item => {
          return !this.groupEditFormData.editGroupSample.some(inItem => inItem.sample === item.sample)
        })
        this.groupEditFormData.projectId = row.projectId
        this.editGroupDialogVisible = true
      }).catch(()=>{
        this.$messageUi.error('分组样本信息获取失败')
      })

    },
    //关闭编辑按钮的dialog
    closeEditGroupDialog() {
      this.editGroupDialogVisible = false
    },
    //点击确认修改按钮
    async handleConfirmEdit() {
      if (this.groupEditFormData.editGroupName === "") {
        this.$messageUi.error("组名不能为空")
      } else if (this.groupEditFormData.editGroupName.trim().includes(" ")) {
        this.$messageUi.error("组名之间不能有空格，请检查")
      } else {
        var length = this.groupEditFormData.editGroupSample.length
        if (length === 0) {
          this.$messageUi.error("组内样本不能为空，至少选择一个样本")
        } else {
          let returnSamples = []
          this.groupEditFormData.editGroupSample.forEach(item => {
            returnSamples.push(item.sample)
          })
          // this.groupEditFormData.editGroupSample =returnSamples
          await this.confirmEdit(returnSamples)
        }
      }
    },
    //提交修改信息
    async confirmEdit(returnSamples) {
      let sendData = new FormData
      sendData.set('groupNewName', this.groupEditFormData.editGroupName.trim())
      sendData.set('groupNewSample', returnSamples.join(","))
      sendData.set('projectId', this.groupEditFormData.projectId)
      sendData.set('groupId', this.groupEditFormData.groupId)
      sendData.set('editorId', this.user.userId?this.user.userId:0)
      const res = await this.$http.post('group/edit', sendData)
      if (res) {
        if (res.code === 200) {
          this.closeEditGroupDialog()
          await this.updataData()
          await this.getGroupPageData()
          this.$messageUi.success('修改成功')
        } else {
          this.$messageUi.error(res.message)
        }
      }
    },
    //点击删除按钮
    async handleDelete(index, row) {
      this.beforeEditGroupData.editGroupName = row.groupName
      this.beforeEditGroupData.projectId = row.projectId
      const res = await this.$confirmUi('此操作将永久删除该组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (res === 'confirm') {
        await this.deleteGroup()
      }
    },
    //提交删除信息
    async deleteGroup(projectId, groupName) {
      const res = await this.$http.post('group/delete', this.beforeEditGroupData)
      if (res) {
        if (res.code === 200) {
          this.$messageUi.success('删除成功!')
          await this.updataData()
          await this.getGroupPageData()
        } else {
          this.$messageUi.error('删除失败!')
        }
      }

    },
    //点击页面表格的内容
    handleSelectionChange(rows) {
      this.multipleSelectAry = rows
    },
    //选择多行删除按钮
    async onMultipleDel() {
      if (this.multipleSelectAry.length === 0) {
        this.$messageUi.error('请选择你要删除的数据')
      } else {
        const res = await this.$confirmUi('此操作将永久删除这些分组, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)
        if (res === 'confirm') {
          await this.deletesGroup()
        }
      }
    },
    //提交多条数据的删除
    async deletesGroup() {
      const res = await this.$http.post('group/deletes', this.multipleSelectAry)
      if (res) {
        if (res.code === 200) {
          this.$messageUi.success('批量删除成功!')
          await this.updataData()
          await this.getGroupPageData()
        } else {
          this.$messageUi.error('批量删除失败!')
        }
      }
    },
    //检查分组文件
    async checkGroupFile(file) {
      var that = this
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        if (!file) {
          resolve(false)
        }
        reader.readAsText(file, 'UTF-8')// 如果出现乱码，可以更换编码
        if (typeof FileReader === 'undefined') {
          that.$messageUi.error('你的浏览器不支持')
        }
        reader.onload = function (e) {
          let text = reader.result
          let line = text.trim().split('\n')
          let sample = line[0].trim().split('\t')
          resolve(that.checkContent(sample))
        }
      })
    },
    //检查上传的分组文件的内容
    checkContent(sample) {
      if (sample[0].toUpperCase() !== 'ID'&&sample[0].toUpperCase() !== 'SAMPLE') {
        this.$messageUi.error('分组文件第 1 行格式错误，表头左列应为‘Id或者Sample’，不区分大小写！')
        return false
      } else if ((sample[1].toUpperCase() !== 'GROUP')) {
        this.$messageUi.error('分组文件第 2 行格式错误，表头右列应为‘Group’，不区分大小写！')
        return false
      } else {
        return true
      }
    },
    handleConfirm(data, isGroup) {
      if (isGroup) {
        this.checkedSampleGroup = data.map(item => {
          return{
            groupName:item.groupName,
            samples:item.contents
          }
        })
        this.saveInputGroup()
      } else {
        this.groupEditFormData.editGroupSample = data.map(item => {
          return {
            sample: item.content,
          }
        })
        this.handleConfirmEdit()
      }
    },
    handleTransCancel(isGroup){
      if(isGroup){
        this.inputGroupDialogVisible=false
      }else {
        this.editGroupDialogVisible=false
      }
    }
  }
}

</script>

<style lang="scss" scoped>
::v-deep .div-sample-group .cell {
  padding: 0px;
}

.btn-add {
  margin: 20px;
}


.el-breadcrumb {
  line-height: 40px;
}

::v-deep .el-checkbox {
  margin-bottom: auto !important;
}

::v-deep.el-table__body td {
  white-space: nowrap;
}
/*.tableCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 25px;
  justify-content: center;

}

::v-deep .div-sample-group .cell {
  padding: 0px;
}

.tableRight {
  min-width: 290px;
  margin-left: 20px;

}

.sample-group-item {
  display: flex;
  align-items: center;
}

.sample-group-item-contents div {
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ebeef5;
}

.transTable {
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: auto;
  max-height: 400px;
}*/
</style>
